import AppleSignin from 'react-apple-signin-auth';
import { AppleAuthResponse } from 'react-apple-signin-auth';
import { Providers } from '../types';
import { message } from 'antd';

interface IAppleSignInButton {
  handleLogin: (authToken: string, provider: Providers) => void;
}

const AppleSignInButton: React.FC<IAppleSignInButton> = ({ handleLogin }) => (
  <AppleSignin
    authOptions={{
      clientId: 'com.mapanda.mvp.sso',
      scope: 'email name',
      redirectURI: 'https://adminpanel-dev.mapanda.com' + '/login',
      state: 'state',
      nonce: 'nonce',
      usePopup: true
    }}
    uiType="dark"
    className="apple-auth-btn"
    noDefaultStyle={false}
    buttonExtraChildren="Continue with Apple"
    onSuccess={(response: AppleAuthResponse) => {
      if (!response.authorization.id_token) return message.error('Login failed.');
      handleLogin(response.authorization.id_token, 'apple');
    }}
    onError={(error: any) => console.error(error)}
    skipScript={false}
  />
);

export default AppleSignInButton;
